import { Box, Container, Grid, Button, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './styles';

const NotificationBanner = ({ desktopText, mobileText, cta, logoutCta }) => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        background: desktopText && theme.palette.primary.backgroundColor4,
      }}
    >
      <Container maxWidth='lg' disableGutters>
        <Grid
          container
          justifyContent='center'
          alignItems='center'
          sx={cta.disableCta ? styles(theme).bannerText : {}}
        >
          {md ? (
            <Typography variant='body1' color={theme.palette.primary.textColor3}>
              {mobileText}
            </Typography>
          ) : (
            desktopText
          )}

          {!cta.disableCta && (
            <Button
              variant={cta.type === 'solid' ? 'buttonSmall' : 'buttonMedium'}
              sx={cta.type === 'solid' ? styles(theme).solidctastyle : styles(theme).ctastyle}
              onClick={cta.action}
              aria-label={cta.ariaLabel}
            >
              {cta.ctaText}
            </Button>
          )}
          <Box sx={{ paddingLeft: 1 }}>{logoutCta}</Box>
        </Grid>
      </Container>
    </Box>
  );
};

export default NotificationBanner;
